import React from 'react';
import { Text } from 'rsuite';
import GeneralPageLayout from '../components/layout/GeneralPageLayout';

const MaintainancePage = () => {
  return (
    <GeneralPageLayout showAccountDropdown={false}>
      <Text
        as="h1"
        className="pb-20"
      >
        We'll be back soon!
      </Text>
      <Text>The registration system is currently down for maintenance.</Text>
      <Text>Please try again later.</Text>
    </GeneralPageLayout>
  );
};

export default MaintainancePage;
